import { GenericAggregations } from "@/services/api/types";
import React, { useMemo } from "react";
import BottomKPIBar, {
  KPI
} from "@/components/controls/BottomKPIBar/BottomKPIBar";

interface PeopleKPIData extends Record<string, number> {
  total: number;
}

interface Props {
  aggregations?: GenericAggregations<string> | {};
  totalPeople: number;
  isLoading?: boolean;
  onOpenStateChange?: (isOpen: boolean) => void;
}

const PeopleBottomKPIBar: React.FC<Props> = ({
  totalPeople,
  isLoading = false,
  onOpenStateChange
}) => {
  const kpis: KPI<PeopleKPIData>[] = [{ name: "total" }];

  const data: PeopleKPIData = useMemo(() => {
    return {
      total: totalPeople
    };
  }, [totalPeople]);

  return (
    <BottomKPIBar<PeopleKPIData>
      kpis={kpis}
      data={data}
      pageName="people"
      isLoading={isLoading}
      onOpenStateChange={onOpenStateChange}
    />
  );
};

export default PeopleBottomKPIBar;
